import { useState, useEffect, useMemo } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ScheduledCall {
  id: string;
  contact_id: string;
  deal_id: string | null;
  title: string | null;
  scheduled_for: string;
  channel: 'voice' | 'video';
  handled_by_app_user_id: string | null;
}

export function useScheduledCallsByContact() {
  const [calls, setCalls] = useState<ScheduledCall[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadScheduledCalls = async () => {
      const now = new Date().toISOString();
      
      const { data, error } = await supabase
        .from('calls')
        .select('id, contact_id, deal_id, title, scheduled_for, channel, handled_by_app_user_id')
        .not('contact_id', 'is', null)
        .eq('status', 'scheduled')
        .gt('scheduled_for', now)
        .order('scheduled_for', { ascending: true });

      if (error) {
        console.error('Error loading scheduled calls by contact:', error);
        setCalls([]);
      } else {
        setCalls((data as ScheduledCall[]) || []);
      }
      setLoading(false);
    };

    loadScheduledCalls();
  }, []);

  // Map: contact_id -> next scheduled call (the earliest one)
  const scheduledCallsByContact = useMemo(() => {
    const map = new Map<string, ScheduledCall>();
    
    for (const call of calls) {
      if (call.contact_id && !map.has(call.contact_id)) {
        map.set(call.contact_id, call);
      }
    }
    
    return map;
  }, [calls]);

  return { scheduledCallsByContact, loading };
}
